// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"MainSection_mainSection__3oxPz","videoListWrapper":"MainSection_videoListWrapper__27XxG","title":"MainSection_title__3nmf7"};